import { defineComponent as _defineComponent } from 'vue'
import { LegacyChecklistRecord } from '@/ui/pages/inspection/LegacyChecklistRecord';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { useConductStore } from '@/stores/conduct/conduct';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionTitle',
  props: {
    record: null
  },
  setup(__props: any) {

const props = __props as {
    record: LegacyChecklistRecord;
  };

  

  const conductStore = useConductStore();

  const showTranslated = conductStore.isTranslationEnabled && props.record.checklist_title_translated;

  const title = showTranslated
    ? props.record.checklist_title_translated as string
    : props.record.checklist_title;

return { __sfc: true,props, conductStore, showTranslated, title, PageSubtitle, Tooltip }
}

})